import React, { Fragment } from 'react'
import { useEffect, useContext } from 'react'
import MyContext from '../../context/MyContext'
import * as Constants from '../../Constants'
import AppointmentInput from '../appointmentFormLogic/AppointmentInput'
import ContactInput from '../contactFormLogic/ContactInput'

const CleanGiveaway = () => {
  const {serviceTypes, fetchServiceTypes, customer} = useContext(MyContext)

  useEffect(() => {
    if(serviceTypes.length == 0){
      fetchServiceTypes(Constants.DEEP_CLEAN);
    }
  }, [])

  return (
    <Fragment>
      {!customer.customerID ? <ContactInput title={'Giveaway'} description={'Enter to win a deep clean!'} hideAreas={true} giveawayType={'Deep Clean Giveaway'}/> : <h1>You've been entered in the giveaway!</h1>}
    </Fragment>
  )
}

export default CleanGiveaway